import { BLASTDOG_DATASET_NAME } from "./DisplayPaneConstants";

export function LayerNameToColumnLayerIdentifier(layerPathSplit: string[], fileName: string) {
	if (
		(layerPathSplit[0] === BLASTDOG_DATASET_NAME.toLowerCase() && layerPathSplit.length >= 3) ||
		(layerPathSplit[0] !== BLASTDOG_DATASET_NAME.toLowerCase() && layerPathSplit.length >= 2)
	) {
		return layerPathSplit.pop() + "/" + fileName;
	}
	return;
}
